import { Typography, Grid } from '@mui/material';
import StyledModal from '../StyledModal';
import { Button } from '../../common';
import colors from '../../../assets/colors';

export default function ParametersWarningModal(props) {
  const handleClose = () => props.setOpen(false);

  return (
    <>
      <StyledModal open={props.open} handleClose={handleClose}>
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          sx={{ mb: 2 }}
          direction="column"
        >
          <Typography sx={{ fontSize: 36, fontWeight: 500 }}>
            KOMUNIKAT
          </Typography>
          <Typography
            sx={{ fontSize: 24, fontWeight: 500, color: colors.agroweGreen }}
          >
            UWAGA : Edycja głównych wskaźników wpłynie na dane wyświetlane w
            aktualnym portfelu klientów !
          </Typography>
        </Grid>
        <Grid container justifyContent="right">
          <Button variant="contained" onClick={() => props.confirm()}>
            POTWIERDŹ
          </Button>
        </Grid>
      </StyledModal>
    </>
  );
}
